<template>
  <div
    class="planning-pool-ship-order-id"
    :class="{ 'has-error': !!errors.length }"
  >
    <div class="planning-pool-ship-order-id-row">
      <InfoIcon
        v-for="error in errors"
        :key="error"
        icon="pi pi-exclamation-triangle"
        :tooltip="error"
        class="error"
      />

      {{ shipOrder.compositeId }}
    </div>

    <div
      v-if="containingShipments.length"
      class="containing-shipments planning-pool-ship-order-id-row align-items-start"
    >
      <ProposedShipmentIcon
        v-for="shipment in containingShipments"
        :key="shipment.identifier"
        :proposed-shipment="shipment"
        :title="
          t('routeBuilder.paramOnProposedShipment', {
            param: t('shipOrders.shipOrders'),
            proposedShipmentIdentifier: shipment.identifier,
          })
        "
        class="containing-shipment-icon"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ProposedShipment, ValidShipOrder } from '@/model/routeBuilder';
import { RoutePlanProposedShipment } from '@/model/routeBuilder/phase2';

import ProposedShipmentIcon from '@/components/routeBuilder/planningPool/ProposedShipmentIcon.vue';
import InfoIcon from '@rygen/rygen-ui/components/ui/InfoIcon.vue';

const props = defineProps({
  shipOrder: {
    type: Object as PropType<ValidShipOrder>,
    required: true,
  },
  proposedShipments: {
    type: Array as PropType<ProposedShipment[] | RoutePlanProposedShipment[]>,
    default: () => [],
  },
  errors: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
});
const { shipOrder, proposedShipments, errors } = toRefs(props);

const { t } = useI18n();

const containingShipments = computed(() => {
  return proposedShipments.value.filter((s) => s.hasShipOrder(shipOrder.value));
});
</script>

<style>
.planning-pool-ship-order-id {
  display: flex;
  gap: var(--gap-1);
  align-items: center;
  flex-direction: column;

  .planning-pool-ship-order-id-row {
    display: flex;
    gap: var(--sp-2);
    align-items: center;
    width: 100%;

    .info-icon-container {
      color: var(--danger-color);
    }
  }
}
</style>
